"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _Option = require("./Option");

var _Option2 = _interopRequireDefault(_Option);

var _lodash = require("lodash");

var _functional = require("../../../utils/functional");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Customiser',

  components: {
    Option: _Option2.default
  },

  props: ['productId', 'productHandle'],

  data: function data() {
    return {
      configuration: null,
      currentGroup: -1,
      state: {},
      variantId: "",
      priceLoading: true,
      currentPriceCents: 0,
      quantity: 1,
      consent: false,
      invalidGroupId: null
    };
  },


  watch: {
    state: (0, _lodash.debounce)(function () {
      this.requestPrice();
    }, 200)
  },

  computed: {
    formattedPrice: function formattedPrice() {
      return (0, _functional.formatMoney)(this.currentPriceCents);
    },


    // Returns a list of all options with their values
    options: function options() {
      var _this = this;

      // Create option store
      var options = [];

      // Loop all option groups in config...
      this.configuration.optionGroups.forEach(function (group) {
        // Loop each option in the group...
        group.options.forEach(function (option) {
          if (!_this.optionConditionsMet(option)) return;

          // Create a new option store for single option
          var newOption = {
            label: option.name,
            value: '-',
            rawValue: '',
            valid: _this.optionValid(option)
          };

          if ([-1, -2].includes(option.id)) {
            newOption.value = 'This field is required';

            if (_this.state["option_" + option.id] !== "") {
              newOption.value = _this.state["option_" + option.id] + " MM";
              newOption.rawValue = _this.state["option_" + option.id];
            }
          }

          // If we have a value in our state for this option...
          else if (_this.state["option_" + option.id]) {
              // Find the value from the option config by id
              var value = option.values.find(function (value) {
                return value.id === _this.state["option_" + option.id];
              });

              // If we have a valid value, add the value to the option object
              if (value) {
                newOption.value = value.label;
                newOption.rawValue = value.value;
              }
            }

          // Push the option object to our options store
          options.push(newOption);
        });
      });

      // Return options store
      return options;
    },
    conditionalGroups: function conditionalGroups() {
      var _this2 = this;

      return this.configuration.optionGroups.filter(function (group) {
        return _this2.groupHasVisibleOptions(group);
      });
    },
    widthValid: function widthValid() {
      var widthOption = this.configuration.optionGroups[0].options.find(function (option) {
        return option.id === -1;
      });
      return this.state['option_-1'] >= widthOption.min && this.state['option_-1'] <= widthOption.max;
    },
    heightValid: function heightValid() {
      var heightOption = this.configuration.optionGroups[0].options.find(function (option) {
        return option.id === -2;
      });
      return this.state['option_-2'] >= heightOption.min && this.state['option_-2'] <= heightOption.max;
    },
    formValid: function formValid() {
      var _this3 = this;

      var valid = this.consent;
      this.conditionalGroups.forEach(function (group) {
        if (valid === true) {
          valid = _this3.groupValid(group);
        }
      });
      return valid;
    }
  },

  methods: {
    // Opens a group of options by setting the currentGroup data variable to the group id that we want opened
    openGroup: function openGroup(groupId) {
      this.currentGroup = groupId;
    },


    // Event handler for the option changed event
    optionChanged: function optionChanged(optionId, value, group) {
      // Create a clone of the state but add / change the optionid with the value
      var newState = (0, _assign2.default)({}, this.state, (0, _defineProperty3.default)({}, "option_" + optionId, value));

      // Overwrite state with new state (triggers reactivity)
      this.state = newState;

      this.handleGroupValidation(group);
    },


    // Create a string of the group choices which is used next to the group name
    groupChoices: function groupChoices(group) {
      var _this4 = this;

      // Group 0 is always the measurements which lives outside of the configuration
      if (group.id === -1) {
        return "";
      }

      // Create store for values
      var groupValues = [];

      // For each option in the group...
      group.options.forEach(function (option) {

        if (!_this4.optionConditionsMet(option)) return;

        // If the option has a value stored in the state...
        if ("option_" + option.id in _this4.state) {
          // Find a matching value object that matatches the ID in the state
          var optionValue = option.values.find(function (value) {
            return value.id === _this4.state["option_" + option.id];
          });

          // If we find a matching value...
          if (optionValue) {
            // Push the value to the value store
            groupValues.push(optionValue.label);
          }
        }
      });

      // Return a string to be appended to the group name in the accordion
      return groupValues.length > 0 ? " / " + groupValues.join(' / ') : "";
    },
    nextGroup: function nextGroup() {
      var _this5 = this;

      // Create a small flat array of group ids and orders
      var flatGroups = this.conditionalGroups.map(function (group) {
        return { id: group.id, order: group.order };
      });

      // Sort them
      flatGroups.sort(function (a, b) {
        if (a.order < b.order) return -1;
        if (a.order > b.order) return 1;
        return 0;
      });

      // Find the index of the current group
      var currentGroupIndex = flatGroups.findIndex(function (group) {
        return group.id === _this5.currentGroup;
      });

      // Return either the next group id, or false
      return flatGroups[currentGroupIndex + 1] !== undefined ? flatGroups[currentGroupIndex + 1].id : false;
    },
    handleGroupValidation: function handleGroupValidation(group) {
      if (this.groupValid(group)) {
        this.invalidGroupId = null;
        return this.nextGroup();
      } else {
        this.invalidGroupId = group.id;
        return this.currentGroup;
      }
    },
    handleButtonClick: function handleButtonClick(group) {
      return this.handleGroupValidation(group);
    },
    requestPrice: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var priceRequest, priceData;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.priceLoading = true;

                // Fetch the config from the app
                _context.next = 3;
                return fetch(window.theme.apiUrl + "/api/price/" + this.productHandle, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: (0, _stringify2.default)({
                    payload: this.state
                  })
                });

              case 3:
                priceRequest = _context.sent;
                _context.next = 6;
                return priceRequest.json();

              case 6:
                priceData = _context.sent;


                if (priceData.price) {
                  this.currentPriceCents = priceData.price;
                  this.priceLoading = false;
                } else {
                  this.currentPrice = 0;
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function requestPrice() {
        return _ref.apply(this, arguments);
      }

      return requestPrice;
    }(),
    resetState: function resetState(e) {
      e.preventDefault();

      this.state = (0, _assign2.default)({}, this.configuration.defaultState);

      var measurementInputs = document.querySelectorAll('.pcm-Option_Input');

      measurementInputs.forEach(function (measurementInput) {
        measurementInput.value = '';
      });

      return this.currentGroup = -1;
    },
    decreaseQuantity: function decreaseQuantity(e) {
      e.preventDefault();

      if (this.quantity > 1) {
        this.quantity -= 1;
      }
    },
    increaseQuantity: function increaseQuantity(e) {
      e.preventDefault();
      this.quantity += 1;
    },
    optionConditionsMet: function optionConditionsMet(option) {
      var _this6 = this;

      if (option.conditions.length === 0) return true;

      return option.conditions.every(function (condition) {
        return "option_" + condition.optionId in _this6.state && _this6.state["option_" + condition.optionId] === condition.valueId;
      });
    },
    groupHasVisibleOptions: function groupHasVisibleOptions(group) {
      var _this7 = this;

      return group.options.some(function (option) {
        return _this7.optionConditionsMet(option);
      });
    },
    formSubmit: function formSubmit(e) {
      if (!this.widthValid || !this.heightValid) {
        e.preventDefault();
      }
    },
    groupValid: function groupValid(group) {
      var _this8 = this;

      var valid = true;

      group.options.forEach(function (option) {
        if (valid && option.styleType === "input" && option.min && option.max && "option_" + option.id in _this8.state) {
          valid = _this8.optionValid(option);
        }
      });

      return valid;
    },
    optionValid: function optionValid(option) {
      if (option.min && this.state["option_" + option.id] < option.min || option.max && this.state["option_" + option.id] > option.max) {
        return false;
      }
      return true;
    }
  },

  mounted: function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var productConfiguration, productConfigurationJson;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch(window.theme.apiUrl + "/api/product-group/" + this.productHandle);

            case 2:
              productConfiguration = _context2.sent;
              _context2.next = 5;
              return productConfiguration.json();

            case 5:
              productConfigurationJson = _context2.sent;


              // Set the variant ID
              this.variantId = productConfigurationJson.variantId;

              // Set state configuration
              this.configuration = productConfigurationJson.configuration;
              this.state = (0, _assign2.default)({}, this.configuration.defaultState);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }()
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//